export var reportResults = {
    ACTION_REQUIRED: 'Action Required',
    NO_ACTION_REQUIRED: 'No Action Required',
    MARGINAL_RESULTS: 'Marginal Results',
    PENDING: 'Pending'
}



// WEBPACK FOOTER //
// ./web-app/constants/report-constants.js